import { getCategoryName } from "@models";
import { useStore } from "@stores";
import { useEffect } from "react";

/**
 * @param enabled pass `false` to skip the fetch on screens that only
 * conditionally need the full category list.
 */
export const useCategories = (enabled = true) => {
  const { categoryStore } = useStore();
  const { categories, loading, loaded } = categoryStore;

  useEffect(() => {
    if (enabled && categories.length === 0) {
      categoryStore.getAll();
    }
  }, [categoryStore, enabled, categories.length]);

  return { categories, loading, loaded, getCategoryName };
};
